export default function (easeLive) {
  easeLive.dispatcher.on('*.error', function (e) {
    console.error(e);
  });
}